import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class SliderService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slider: [
                {
                    id: 1,
                    srcimg: 'assets/img/imagebox/bg1.jpeg',
                    heading: 'BLOCK BOARDS & MDF',
                    text: 'High-quality block boards and MDF boards in various sizes for all your construction and furniture needs...'
                },
                {
                    id: 2,
                    srcimg: 'assets/img/imagebox/bg2.jpeg',
                    heading: 'PLYWOOD & CHIP BOARDS',
                    text: 'Premium plywood in 3mm, 6mm, 9mm sizes, marine boards, MDF veneers, and veneer ply for superior finishes...'
                },
                {
                    id: 3,
                    srcimg: 'assets/img/imagebox/bg3.jpeg',
                    heading: 'DOORS & HARDWARE',
                    text: 'Wide selection of flash doors, mahogany doors, hinges, locks, and complete door hardware solutions...'
                },
                {
                    id: 4,
                    srcimg: 'assets/img/imagebox/bg4.jpeg',
                    heading: 'TOOLS & EQUIPMENT',
                    text: 'Professional-grade hammers, screwdrivers, pliers, measuring tools, and everything you need for construction...'
                },
                {
                    id: 5,
                    srcimg: 'assets/img/imagebox/bg5.jpeg',
                    heading: 'PAINTS & FINISHES',
                    text: 'Complete range of paints, wood finishes, sandpaper, and lipping materials from trusted brands like Cona...'
                },
                {
                    id: 6,
                    srcimg: 'assets/img/imagebox/bg6.jpeg',
                    heading: 'SCREWS & FASTENERS',
                    text: 'Comprehensive selection of screws, nails, concrete nails, and fasteners for all construction applications...'
                }
            ]
        }
    }
    
    render() {
        return (
            <div className="themesflat-carousel-box has-arrows arrow-center offset-v-111 offset-h-21 arrow-circle arrow-style-2 data-effect clearfix"
                data-gap={30} data-column={3} data-column2={2} data-column3={1} data-auto="true">
                <div className="owl-carousel owl-theme">
                    {
                        this.state.slider.map(data =>(
                            <div className="themesflat-image-box style-2 clearfix" key={data.id}>
                                <div className="image-box-item">
                                    <div className="inner">
                                        <div className="thumb data-effect-item">
                                            <img src={data.srcimg} alt="altimage" />
                                            <div className="overlay-effect bg-color-accent" />
                                        </div>
                                        <div className="text-wrap">
                                            <h5 className="heading"><Link to="#">{data.heading}</Link></h5>
                                            <p>{data.text}</p>
                                            <div className="elm-readmore">
                                                <Link to="#">DETAILS</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }             
                </div>
            </div>
        );
    }
}

export default SliderService;